import { getSemanticEligibilityScore } from '@mediaingenuity/totallymoney.cardloanutils'

import Heading from '@totallymoney/ui/components/Heading'
import Text from '@totallymoney/ui/components/Text'

import { ScoredCreditCardProduct } from '@appTypes/EligibilityApi.interface'

import { getDisplayScore } from '@utils/getDisplayScore'
import { getEligibilityArticle } from '@utils/getElgiibilityArticle'

const getEligibleContent = (card: ScoredCreditCardProduct) => {
    const displayScore = getDisplayScore(card.score)
    const semanticScore = getSemanticEligibilityScore(displayScore)

    if (card.isPreApproved) {
        return (
            <>
                <Heading variant="40">Great news!</Heading>
                <Text variant="120">You’re pre-approved for a {card.name}</Text>
            </>
        )
    }

    if (displayScore >= 81) {
        return (
            <>
                <Heading variant="40">Good news!</Heading>
                <Text variant="120">
                    You have {getEligibilityArticle(semanticScore)}{' '}
                    {semanticScore?.toLowerCase()} elegibility for a {card.name}
                </Text>
            </>
        )
    }

    return (
        <>
            <Heading variant="40">Good news!</Heading>
            <Text variant="120">You could be eligibile for a {card.name}</Text>
        </>
    )
}

export default getEligibleContent
